export const BUILD_VERSION = '1791459983';
